module.exports = __webpack_public_path__ + "static/media/searchbox.62acfeee.png";